import 'alpinejs'
import smoothscroll from 'smoothscroll-polyfill';

let Turbolinks = require('turbolinks');

Turbolinks.start()
smoothscroll.polyfill();
